export default __webpack_public_path__ + "static/media/illust_pc_kor.73d6d21d.png";